(function () {
  'use strict';

  angular
  .module('service.http', [])

  /* @ngInject */
  .factory('HttpService', ["$http", function ($http) {
    return {
      get: function (object) {
        return $http({
          method: 'GET',
          url: object.url,
          cache: object.cache,
          headers: {
            'Content-type': 'application/json',
            'X-Requested-With': 'jsonHttpRequest'
          }
        })
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          throw error;
        });
      },
      post: function (object) {
        return $http({
          method: 'POST',
          data: object.data,
          url: object.url,
          headers: {
            'Content-type': 'application/json',
            'X-Requested-With': 'jsonHttpRequest'
          }
        })
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          throw error;
        });
      }
    };
  }]);

})();
